var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFullHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 237.922,
    height: 51.16,
    viewBox: "0 0 237.922 51.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 168.194,
    height: 51.16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Full",
    "data-name": "Logo Full",
    transform: "translate(-179.091 -61.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(179.09 61.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M19.568,29.616l4.061,7.035h19.2l-3.692,6.394h-19.2l-9.6-16.627,9.6-16.627h19.2L46.89,23.221H57.228L44.306.838H14.768L0,26.418,14.768,52H44.306L57.228,29.616Z",
    transform: "translate(0 -0.838)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M29.305,20.638l-4.061,7.035H45.181L41.12,20.638Z",
    transform: "translate(-5.675 -5.29)",
    fill: "#f07900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(248.818 61.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650-2",
    "data-name": "Group 650",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M.537,27.48V8.89C.537,3.233,3.364,0,8.821,0s8.284,3.233,8.284,8.89v3.031H11.852V8.537c0-2.526-1.111-3.486-2.88-3.486s-2.879.96-2.879,3.486V27.884c0,2.525,1.112,3.434,2.879,3.434s2.88-.908,2.88-3.434V20.963H9.073V15.912h8.033V27.48c0,5.656-2.83,8.889-8.284,8.889S.537,33.136.537,27.48",
    transform: "translate(-0.126 0)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M27.4,30.917v-10c0-5.354,2.829-8.385,7.881-8.385s7.881,3.031,7.881,8.385v10c0,5.354-2.83,8.385-7.881,8.385S27.4,36.271,27.4,30.917m10.407.5V20.411c0-1.769-.556-3.132-2.526-3.132s-2.525,1.363-2.525,3.132V31.422c0,1.819.605,3.131,2.525,3.131S37.8,33.241,37.8,31.422",
    transform: "translate(-6.411 -2.932)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M53.631.659H68.785V5.71h-9.6v9.347h7.628v5.051H59.187v10.86h9.6v5.052H53.631Z",
    transform: "translate(-12.55 -0.154)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M77.914,27.48V25.46h5.253v2.424c0,2.525,1.111,3.434,2.879,3.434s2.931-.908,2.931-3.535c0-2.93-1.213-4.748-4.85-7.93-4.648-4.092-6.213-7.022-6.213-11.064C77.914,3.233,80.793,0,86.2,0S94.28,3.233,94.28,8.89v1.465H89.027V8.537c0-2.526-1.01-3.486-2.779-3.486s-2.828.96-2.828,3.386c0,2.576,1.262,4.395,4.9,7.576,4.647,4.092,6.163,6.972,6.163,11.367,0,5.757-2.93,8.991-8.385,8.991s-8.183-3.233-8.183-8.889",
    transform: "translate(-18.232 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M104.584,27.683V8.689c0-5.455,2.827-8.688,8.183-8.688s8.183,3.233,8.183,8.688v3.739H115.7V8.334c0-2.323-1.11-3.282-2.777-3.282s-2.778.96-2.778,3.282V28.086c0,2.324,1.112,3.233,2.778,3.233s2.777-.908,2.777-3.233V22.934h5.255v4.748c0,5.454-2.829,8.687-8.183,8.687s-8.183-3.233-8.183-8.687",
    transform: "translate(-24.473 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M131.338.659h8.233c5.76,0,8.235,2.677,8.235,8.133v2.171c0,3.638-1.162,5.961-3.637,6.972v.1c2.778.859,3.688,3.486,3.688,7.477v6.211a10.407,10.407,0,0,0,.606,4.294H142.8c-.3-.91-.5-1.465-.5-4.345V25.208c0-3.282-.96-4.343-3.486-4.343h-1.919V36.019h-5.557Zm7.576,15.155c2.071,0,3.335-.91,3.335-3.739V9.348c0-2.526-.859-3.638-2.829-3.638h-2.526v10.1Z",
    transform: "translate(-30.733 -0.154)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M158.391,27.48V8.889c0-5.657,2.98-8.889,8.435-8.889s8.436,3.233,8.436,8.889V27.48c0,5.656-2.98,8.889-8.436,8.889s-8.435-3.233-8.435-8.889m11.315.354V8.537c0-2.526-1.111-3.486-2.88-3.486s-2.879.96-2.879,3.486v19.3c0,2.524,1.112,3.484,2.879,3.484s2.88-.96,2.88-3.484",
    transform: "translate(-37.064 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M184.822.659h5.354L192.7,28.341,195.379.659h6.062l2.677,27.682L206.643.659h4.8l-3.587,35.36h-6.921l-2.576-24.3-2.576,24.3h-7.374Z",
    transform: "translate(-43.249 -0.154)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M0,63.913V55.136H2.336a7.123,7.123,0,0,1,1.707.126,1.934,1.934,0,0,1,1.057.867,3.2,3.2,0,0,1,.416,1.713,3.24,3.24,0,0,1-.359,1.6,2.086,2.086,0,0,1-.9.9A4.657,4.657,0,0,1,2.4,60.6H1.449v3.311Zm1.449-7.292v2.5h.8A3.5,3.5,0,0,0,3.354,59a.978.978,0,0,0,.477-.411,1.514,1.514,0,0,0-.005-1.467.945.945,0,0,0-.475-.4,4.325,4.325,0,0,0-1.193-.1Z",
    transform: "translate(0 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M18.148,63.912H16.574l-.631-1.988H13.061l-.6,1.988H10.922l2.8-8.777h1.539ZM15.475,60.44l-.994-3.257-.974,3.257Z",
    transform: "translate(-2.556 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M25.893,63.912v-3.7l-2.634-5.082h1.7l1.691,3.471,1.668-3.471h1.671l-2.646,5.093v3.684Z",
    transform: "translate(-5.443 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M37.039,63.912V55.136h2.173l1.309,5.993,1.3-5.993H44v8.777H42.649V57l-1.435,6.915h-1.4L38.393,57v6.915Z",
    transform: "translate(-8.667 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M52.087,63.912V55.136h5.341V56.62H53.536v1.946h3.616v1.478H53.536v2.383H57.56v1.484Z",
    transform: "translate(-12.188 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M64.938,63.912V55.136h1.413L69.3,61V55.136H70.65v8.777H69.189l-2.9-5.724v5.724Z",
    transform: "translate(-15.196 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M79.935,63.912V56.62H77.8V55.136h5.718V56.62H81.384v7.292Z",
    transform: "translate(-18.205 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M98.3,63.913V55.136h2.336a7.123,7.123,0,0,1,1.707.126,1.934,1.934,0,0,1,1.057.867,3.2,3.2,0,0,1,.416,1.713,3.24,3.24,0,0,1-.359,1.6,2.086,2.086,0,0,1-.9.9,4.657,4.657,0,0,1-1.856.26h-.952v3.311Zm1.449-7.292v2.5h.8a3.5,3.5,0,0,0,1.1-.114.978.978,0,0,0,.477-.411,1.514,1.514,0,0,0-.005-1.467.945.945,0,0,0-.475-.4,4.325,4.325,0,0,0-1.193-.1Z",
    transform: "translate(-23.003 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M111.147,63.912V55.135h3.06a4.257,4.257,0,0,1,1.676.237,1.857,1.857,0,0,1,.826.82,2.85,2.85,0,0,1,.323,1.4,2.6,2.6,0,0,1-.494,1.658,2.195,2.195,0,0,1-1.4.791,3.6,3.6,0,0,1,.772.733,10.239,10.239,0,0,1,.833,1.428l.875,1.712H115.88L114.828,62a12.376,12.376,0,0,0-.771-1.3,1.135,1.135,0,0,0-.43-.359,1.972,1.972,0,0,0-.73-.1h-.3v3.664Zm1.449-5.065h1.078a5.428,5.428,0,0,0,1.258-.087.8.8,0,0,0,.437-.35,1.291,1.291,0,0,0,.168-.7,1.2,1.2,0,0,0-.168-.673.848.848,0,0,0-.455-.35,5.709,5.709,0,0,0-1.18-.066H112.6Z",
    transform: "translate(-26.009 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M124.313,59.532a6.233,6.233,0,0,1,.464-2.584,3.5,3.5,0,0,1,1.212-1.512,3.212,3.212,0,0,1,1.815-.5,3.114,3.114,0,0,1,2.518,1.179,5.152,5.152,0,0,1,.973,3.36,5.231,5.231,0,0,1-1.03,3.442,3.323,3.323,0,0,1-4.921.012,5.163,5.163,0,0,1-1.03-3.4m1.5-.061a3.729,3.729,0,0,0,.576,2.273,1.732,1.732,0,0,0,1.426.757,1.711,1.711,0,0,0,1.422-.751,3.853,3.853,0,0,0,.564-2.309,3.758,3.758,0,0,0-.549-2.257,1.712,1.712,0,0,0-1.436-.73,1.732,1.732,0,0,0-1.444.735,3.778,3.778,0,0,0-.558,2.281",
    transform: "translate(-29.09 -12.856)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M140.458,63.912V56.62h-2.137V55.136h5.718V56.62h-2.132v7.292Z",
    transform: "translate(-32.368 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M151.1,63.912V55.136h5.341V56.62h-3.892v1.946h3.616v1.478h-3.616v2.383h4.024v1.484Z",
    transform: "translate(-35.358 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M168.463,60.64l1.407.545a3.945,3.945,0,0,1-1.1,2.152,2.741,2.741,0,0,1-1.887.679,2.791,2.791,0,0,1-2.28-1.083,5.238,5.238,0,0,1-1.007-3.377,5.5,5.5,0,0,1,1.013-3.515,2.873,2.873,0,0,1,2.367-1.1,2.732,2.732,0,0,1,2.026.826,3.577,3.577,0,0,1,.85,1.742l-1.437.42a1.941,1.941,0,0,0-.548-1.093,1.379,1.379,0,0,0-.968-.38,1.542,1.542,0,0,0-1.3.694,4,4,0,0,0-.5,2.293,4.25,4.25,0,0,0,.492,2.359,1.494,1.494,0,0,0,1.275.7,1.32,1.32,0,0,0,.994-.446,2.828,2.828,0,0,0,.6-1.416",
    transform: "translate(-38.283 -12.856)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M178.951,63.912V56.62h-2.137V55.136h5.718V56.62H180.4v7.292Z",
    transform: "translate(-41.375 -12.902)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 1.449,
    height: 8.777,
    transform: "translate(145.181 42.234)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M196.937,59.532a6.232,6.232,0,0,1,.464-2.584,3.5,3.5,0,0,1,1.212-1.512,3.212,3.212,0,0,1,1.815-.5,3.114,3.114,0,0,1,2.518,1.179,5.152,5.152,0,0,1,.973,3.36,5.231,5.231,0,0,1-1.03,3.442,3.323,3.323,0,0,1-4.921.012,5.163,5.163,0,0,1-1.03-3.4m1.5-.061a3.73,3.73,0,0,0,.576,2.273,1.732,1.732,0,0,0,1.426.757,1.711,1.711,0,0,0,1.422-.751,3.852,3.852,0,0,0,.564-2.309,3.758,3.758,0,0,0-.549-2.257,1.712,1.712,0,0,0-1.436-.73,1.732,1.732,0,0,0-1.444.735,3.778,3.778,0,0,0-.558,2.281",
    transform: "translate(-46.084 -12.856)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M211.641,63.912V55.136h1.413L216,61V55.136h1.354v8.777h-1.461l-2.9-5.724v5.724Z",
    transform: "translate(-49.525 -12.902)",
    fill: "#525252"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullHorizontal);
export default __webpack_public_path__ + "static/media/logo-full-horizontal.a2884b43a7129d6af8a35302a67600a1.svg";
export { ForwardRef as ReactComponent };